import { Pipe, PipeTransform } from "@angular/core";
import { Util } from "../util/util";

@Pipe({
    name: 'horaFormatadaPipe',
    pure: true
  })
  
export class HoraFormatadaPipe implements PipeTransform {

    transform(hora: any, args?: any): any {
        return Util.getHoraFormatada(hora);
    }

}
